import { Component, Input, NgZone, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { amount, codeOnly, generateCheckDigit, JobDto, JobLineDto, JobVat, newJobLine, StockMasterDto } from "@shared/models";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PHONE_MASK, PHONE_REGEX, convertToDate, convertToNgbDate } from "../../common";
import { AppQuery } from "../../common/app.store";
import { BaseFormDirective } from "../../common/components";
import { JobService, ProductSettingService, WebLayoutService } from "../../common/services";


export interface Profile {
  width: string;
  height: string;
  src: string;
  name: string;
  email: string;
  // pages: { id: string, name: string }[];
  id: string;
  firstName: string;
  lastName: string;
}

@Component({
  selector: "abi-facebook-create",
  templateUrl: "./facebook-create.component.html",
  styleUrls: ["./facebook-create.component.scss"]
})
export class FacebookCreateComponent extends BaseFormDirective implements OnInit {
  validationMessages = {
    firstName: {
      required: "First name required"
    },
    lastName: {
      required: "Last name required"
    },
    mobile: {
      required: "Telephone required",
      pattern: "Not a valid number"
    },
    emailAddress: {
      email: "Not a valid email address."
    },

    field3: {
      required: "Posting date required",
      ngbDate: "Posting date required"
    },
    line1: {
      required: "Address required"
    },
    donation: {
      required: "Type of donation required"
    }
  };

  @Input() get boundJob(): JobDto {
    return this.job;
  }
  set boundJob(value: JobDto) {
    if (!this.form) {
      setTimeout(() => this.boundJob = value, 5);
    } else {
      if (this.job !== value && value) {
        // this.displayJob(value);
        this.readonly = value.lines.some(l => !!l.quantityDelivered);
        this.setFormData(value);
        this.facebookId = value.contact.instantMessageId;
        this.jobService.getFromFacebook(this.facebookId).toPromise().then(jobs => {
          this.paidJobs = jobs.filter(j => j.statusId !== "LOG" && j.jobId !== value.jobId);
        });

        this.jobPath = "../../";
      }
    }
  }
  phoneMask = PHONE_MASK;
  readonly phoneRegex = PHONE_REGEX;

  get donationType(): FormControl {
    return this.form.get("donationType") as FormControl;
  }

  jobPath = "../";
  readonly = false;
  myGateApplicationId: string;
  myGateMode: number;
  facebookId = "";
  profile: Profile;
  job: JobDto;
  tenant: string;
  blockedDays: string[] = [];
  loading = false;

  paidJobs: JobDto[];

  termsAndConditions: Observable<SafeHtml>;
  privacyNotice: Observable<SafeHtml>;
  theText: Observable<SafeHtml>;
  get lines(): FormArray {
    return this.form.get("lines") as FormArray;
  }

  readonly minreqDate = convertToNgbDate(Date.today());

  get unpaid(): number {
    const result = (this.job ? this.job.lines.reduce((amt: number, line: JobLineDto) => amt +
      (!!line.invoice ? 0 : amount(line)), 0) : 0);
    return this.round(result, 2);
  }

  get unpaidForm(): number {
    if (this.lines.invalid) {
      return 0;
    }
    const lineData = this.lines.getRawValue().filter(l => l.quantityOrdered);

    const result = this.lines ? lineData.reduce((amt: number, line: any) => amt +
      (!!line.invoice ? 0 : line.price), 0) : 0;
    return this.round(result, 2);
  }

  included(): SafeHtml[] {
    const result: string[] = [];

    if (this.job) {
      const unpaid = this.job.lines; // .filter(l => !l.invoiceNumber);

      if (unpaid.some((l) => l.typeId === "LAB" && l.itemId === "LabCall")) {
        result.push(`This covers assessment and all labour, but excludes parts.`);
      }

      result.push("3 Months warranty on labour and parts.");
      result.push("For units older than 5 years, parts may not be readily available.");
    }
    return result.map((r) => this.sanitizer.bypassSecurityTrustHtml(r));
  }

  constructor(
    protected layoutService: WebLayoutService,
    private zone: NgZone, private jobService: JobService, private sanitizer: DomSanitizer,
              private productSettings: ProductSettingService, private dialog: MatDialog, formbuilder: FormBuilder,
              private router: Router, private route: ActivatedRoute, private appQuery: AppQuery) {
    super(layoutService, formbuilder);
    JobVat.vatRate = 0.0;

    this.myGateApplicationId = productSettings.stringValue("MyGateApplicationID");
    this.myGateMode = productSettings.numericValue("MyGateApplicationID");

    const wnd: any = window;
    wnd.fbAsyncInit = () => {
      FB.init({
        appId: "1513569318789432",
        xfbml: true,
        version: "v3.0"
      });
      FB.AppEvents.logPageView();
      FB.Event.subscribe("auth.statusChange", this.facebookLoggedIn.bind(this));

      FB.getLoginStatus(response => {
        // console.log("facebooking - status");
        // this.facebookLoggedIn(response);
        // console.log(response);
      });

    };

    if (typeof FB !== "object") {
      this.loadScript(document, "script", "facebook-jssdk");
    } else {
      wnd.fbAsyncInit();
      FB.getLoginStatus(response => {
        this.facebookLoggedIn(response);
      });
    }
  }

  ngOnInit() {
    super.ngOnInit();
    const useMask = this.productSettings.numericValue("PhoneMask") === 0;
    this.phoneMask = useMask ? (this.productSettings.stringValue("PhoneMask") || this.phoneMask) : "";

    this.termsAndConditions = this.getText("TermsAndConditions");
    this.privacyNotice = this.getText("PrivacyNotice");

    this.tenant = this.appQuery.tenant;
  }

  private loadScript(d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    const js: any = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }

  protected createForm() {
    this.form = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      companyName: "",
      emailAddress: ["", Validators.email],

      mobile: ["", Validators.pattern(this.phoneRegex)],
      line1: ["", Validators.required],
      donationType: ["", Validators.required],
      lines: this.formBuilder.array([])
    });
    super.createForm();
  }

  private setFormData(job: JobDto) {
    this.job = job;
    const ena = Math.max(job.lines.findIndex(l => l.paid > 0), -1);

    const lines = job.lines.map(l => this.formBuilder.group({
      quantityOrdered: Math.max(l.quantityOrdered, ena),
      itemId: l.itemId,
      typeId: l.typeId,
      price: l.price,
      field3: convertToDate(l.fields[2]),
      structureId: l.structureId,
      dayCounter: 1,
    }));

    this.form.reset({
      firstName: job.contact.firstName,
      lastName: job.contact.lastName,
      comanyName: job.contact.companyName,
      emailAddress: job.contact.emailAddress,
      mobile: job.contact.mobile,
      line1: job.address.lines[0],
      donationType: ena,
    });
    this.form.setControl("lines", this.formBuilder.array(lines));

    // this.choose(null, ena);

    if (ena < 0) {
      lines.forEach(l => {
        l.disable();
      });
    }
    /*
        setTimeout(() => {
          this.choose(this.job.lines[0], 0);
        }, 2);
    */
    this.validate(true);
  }

  private getFormData() {
    const job = this.job;
    const data = this.form.getRawValue();

    job.contact.firstName = data.firstName;
    job.contact.lastName = data.lastName;
    job.contact.companyName = data.comanyName;
    job.contact.emailAddress = data.emailAddress;
    job.contact.mobile = data.mobile;
    job.address.lines[0] = data.line1;

    for (let i = 0; i < this.lines.length; i++) {
      const lData = (this.lines.at(i) as FormGroup).getRawValue();
      job.lines[i].quantityOrdered = lData.quantityOrdered;
      job.lines[i].itemId = codeOnly(lData.itemId);
      job.lines[i].typeId = codeOnly(lData.typeId);
      job.lines[i].price = lData.price;
      job.lines[i].fields[2] = !!lData.field3 ? convertToDate(lData.field3).format() : "";
      job.lines[i].structureId = lData.structureId;
    }
  }

  getText(id: string): Observable<SafeHtml> {
    return this.productSettings.getText(id).pipe(map((txt) => this.sanitizer.bypassSecurityTrustHtml(txt)));
  }

  changePrice(line: JobLineDto): boolean {
    return line.quantityOrdered && line.typeId === "STK" && !line.invoice;
  }

  private adReference(): string {
    const lineData = this.lines.getRawValue().filter(l => l.quantityOrdered)[0];
    if (lineData && lineData.typeId !== "STK" && lineData.field3) {
      const date = convertToDate(lineData.field3);
      const ctr = lineData.dayCounter ? "-" + lineData.dayCounter : "";
      const amt = Math.floor(lineData.price / 100).toString(36).toUpperCase();
      const year = (date.getFullYear() - 2019).toString(36).toUpperCase();
      const month = (date.getMonth() + 1).toString(16);
      return `BB${year}${month}${date.format("DD")}${amt}${ctr}`;
    }

    return "";
  }

  paymentReference(): string {
    if (this.lines.invalid) {
      return this.job.jobId;
    }
    const result = this.adReference();
    return result ? `${result}__${this.facebookId}` : this.job.jobId;
  }

  changeDate(line: JobLineDto): boolean {
    return line.quantityOrdered && line.itemId === "OnlineAd";
  }

  canPay(): boolean {
    return this.job && this.job.statusId !== "CXC"; // this.unpaid &&
  }

  choose(zzz: JobLineDto, index: number) {
    for (let i = 0; i < this.lines.length; i++) {
      const line = this.lines.at(i);
      if (i === index) {
        line.patchValue({
          quantityOrdered: 1,
        });
        const lValue = line.value;

        line.enable();
        const price = line.get("price");
        if (lValue.typeId !== "STK" && (lValue.structureId.value > 1 || !lValue.field3)) {
          price.disable();
        } else if (price.disabled) {
          price.enable();
        }
      } else {
        line.get("quantityOrdered").setValue(0);
        line.disable();
      }

      this.validateArray(this.lines, "", true);
    }
    return false;
  }

  postbackUrl(): string {
    if (this.job) {
      const tenant = this.appQuery.tenant;
      const root = typeof (window) !== "undefined" ? window.location.origin : "";
      return `${root}/api/${tenant}/payments/facebook/${this.facebookId}/`;
    }
    return "";
  }

  get total(): number {
    return this.job ? this.job.lines.reduce((amt: number, line) => amt + amount(line), 0) : 0;
  }

  private round(num: number, precision: number): number {
    const shift = (n, p, reverseShift) => {
      if (reverseShift) {
        p = -p;
      }
      const numArray = ("" + n).split("e");

      return +(numArray[0] + "e" + (numArray[1] ? +numArray[1] + p : p));
    };

    return shift(Math.round(shift(num, precision, false)), precision, true);
  }

  private facebookLoggedIn(response: fb.StatusResponse) {
    if (response.status !== "connected") {
      return;
    }

    console.log("FB logged in");
    this.facebookId = response.authResponse.userID;
    FB.api(`/${this.facebookId}`, "get", { fields: "id,name,email,picture,accounts,first_name,last_name" }, (grres: any) => {
      if (!this.job) {
        this.profile = {
          id: this.facebookId,
          width: grres.picture.data.width + "px",
          height: grres.picture.data.height + "px",
          src: grres.picture.data.url,
          email: grres.email,
          name: grres.name,
          lastName: grres.last_name,
          firstName: grres.first_name,
          // pages: grres.accounts.data.map(acc => ({ id: acc.id, name: acc.name })),
        };
        this.zone.run(() => {
          this.jobService.getFromFacebook(this.facebookId).toPromise().then(jobs => {
            if (!this.job) {
              const job = jobs.find(j => j.statusId === "LOG");
              this.paidJobs = jobs.filter(j => j.statusId !== "LOG");
              job.contact.lastName = this.profile.lastName;
              job.contact.firstName = this.profile.firstName;
              job.contact.emailAddress = this.profile.email;

              const line = job.lines.filter(l => l.itemId === "OnlineAd")[0];
              this.setFormData(job);
              this.updatePrice(convertToNgbDate(line.fields[2]), line, job.lines.indexOf(line));
              this.setFormData(job);
            }
            // this.changeRef.detectChanges();
          });
        });
      }
    });
  }

  showText(dialog: any, terms: boolean) {
    this.theText = terms ? this.termsAndConditions : this.privacyNotice;
    this.dialog.open(dialog);
    return false;
  }

  makePayment(form: any) {
    let submit = true;
    this.loading = true;
    this.getFormData();
    // this.posting = true;
    const lines = [...this.job.lines];
    this.job.lines = this.job.lines.filter(l => l.quantityOrdered);
    const adref = this.adReference();
    this.job.lines.forEach(l => {
      l.requested = convertToDate(l.requested);
      if (adref && !l.price) {
        l.fields[3] = adref;
        l.fields[4] = Date.today().format("yMMdd");
        l.quantityDelivered = l.quantityOrdered;
        submit = false;
        this.job.statusId = "SUB";
      }
    });
    this.jobService.updateFromFacebook(this.facebookId, this.job).toPromise().then(ok => {
      // this.job.lines = [...lines];
      if (ok && submit) {
        form.submit();
      } else if (ok && !submit) {
        this.router.navigate(["..", this.job.jobId, this.generateJobCheckDigit(this.job.jobId)], { relativeTo: this.route });
      }
    });
  }

  cancelJob(dialog: any) { /*
    const ref = this.modal Service.open(dialog);
    ref.afterClosed().subscribe((cancel: boolean) => {
      if (cancel) {
        this.jobService
          .updateJobLite(this.job.jobId, this.check, {
            statusId: "CXC",

          })
          .toPromise()
          .then((x) => window.close());
      }
    });*/

  }

  updatePrice(date: NgbDateStruct, line: JobLineDto, lineId: number) {
    if (this.readonly) {
      return;
    }

    let aDate = convertToDate(date);
    if (!aDate || isNaN(aDate.valueOf())) {
      aDate = Date.today();
    }
    this.jobService.getStockPrice(line.itemId, this.job.customerId, aDate).toPromise().then(info => {
      line.structureId = "" + info.counter;
      line.price = info.price;
      const fLine = this.lines.at(lineId);
      fLine.patchValue({ price: info.price, structureId: info.counter, dayCounter: info.dayCounter });
      if (info.counter > 1) {
        fLine.get("price").disable();
      } else {
        fLine.get("price").enable();
      }

      this.blockedDays = info.blocked;

      if (!info.allowed) {
        const adLine = this.job.lines.find(l => l.typeId !== "STK");
        let firstDate = convertToDate(adLine.fields[2]);
        let ok = false;
        while (!ok) {
          firstDate = firstDate.add(1, "day");
          const toCheck = firstDate.format();
          ok = !this.blockedDays.includes(toCheck);
        }
        adLine.fields[2] = firstDate as any;
      }

    });
  }

  generateJobCheckDigit(jobId: string): string {
    return generateCheckDigit(jobId);
  }

  createJob() {
    const jobLine = newJobLine("");
    jobLine.typeId = "STK";
    jobLine.cost = 200;
    jobLine.price = 200;
    jobLine.itemId = "OnlineAd";
    jobLine.line1 = "Online Ad";
    jobLine.quantityOrdered = 1;

    const job = this.jobService.jobFactory();
    job.contact.instantMessageId = this.profile.id;
    job.contact.companyName = "Test company #1";
    job.contact.firstName = this.profile.firstName || this.profile.name;
    job.contact.lastName = this.profile.lastName;
    job.contact.afterHours = "(000)000-0000";

    job.address.name = this.profile.name;
    job.address.postalCode = "0000";
    job.address.country = "ZA";
    job.address.lines[0] = "From Facebook";

    job.machine.modelId = "OnlineAd";
    job.machine.name = "Online Ad";
    job.faultDescription = "Online Ad";
    job.lines = [jobLine];

    this.jobService.newJob(job).toPromise().then(x => {
      // console.log(x);
    });
  }

  isBlocked(date: NgbDateStruct) {
    const toCheck = convertToDate(date).format();
    return !this.readonly && this.blockedDays.includes(toCheck);
  }

  activeLine(): JobLineDto[] {
    return this.job ? this.job.lines.filter(l => l.quantityOrdered) : [];
  }

  selectDonation(stk: StockMasterDto, line: JobLineDto) {
    line.line1 = stk.description;
    line.line2 = stk.description2;
  }
}
